import api from '@admin/api/service';
import { BASE_MAMIPAY_PATH } from './_mamipayBase';

export default {
	postUploadMedia(payload, query = '') {
		return api.post(
			`${BASE_MAMIPAY_PATH}/media/upload?${query}`,
			payload,
			{
				headers: {
					Accept: 'application/json',
					'Content-Type': 'multipart/form-data',
				},
			}
		);
	},
};